import {planTypes ,trackingPlanTypes, BASE_PLAN_SUB_TYPES, isPlanIncludeUnlimitedWhiteboard} from "@/common/constants";
import { mapGetters } from 'vuex';

export default {
  key: planTypes.ZOOM_WHITEBOARD,
  data() {
    return {
      title:'',
      subtitle: '',
      planType: planTypes.ZOOM_WHITEBOARD,
      category: BASE_PLAN_SUB_TYPES.WHITEBOARD_BASIC,
      logo: require('@/assets/plans/logo_whiteboard.svg'),
    }
  },
  computed: {
    ...mapGetters(['getTypeGroupSelectedPlans', 'getSelectedPlans']),
    isWhiteboardPlus() {
      return this.category === BASE_PLAN_SUB_TYPES.WHITEBOARD_PLUS
    },
    trackingPlanKey() {
      return this.trackingPlanName
    },
    selectedPlan() {
      return this.getTypeGroupSelectedPlans[this.planType]?.[0];
    },
    // Add-on may be Whiteboard or Whiteboard Plus(OBT-4810)
    // When the Base Plan is Business/Business Plus, Whiteboard Plus is displayed
    // Other cases display Whiteboard
    whiteBoardTypeImpactFactors() {
      return {
        selectedPlan: this.selectedPlan,
        getSelectedPlans: this.getSelectedPlans
      }
    }
  },
  watch: {
    whiteBoardTypeImpactFactors: {
      handler() {
        this.getDefaultTitles();
      },
      deep: true
    }
  },
  methods:{
    getDefaultTitles(){
      const infoMap = {
        [BASE_PLAN_SUB_TYPES.WHITEBOARD_PLUS]: {
          configDescription: this.$t('billing.zoom_whiteboard_plus.desc'),
          addonDescription: this.$t('billing.zoom_whiteboard_plus.add_on_desc'),
          title: this.$t('billing.zoom_whiteboard_plus.title'),
          trackingPlanName: trackingPlanTypes.ZOOM_WHITEBOARD_PLUS
        },
        [BASE_PLAN_SUB_TYPES.WHITEBOARD_BASIC]: {
          configDescription: this.$t('billing.zoom_whiteboard.desc'),
          title: this.$t('billing.zoom_whiteboard.title'),
          trackingPlanName: trackingPlanTypes.ZOOM_WHITEBOARD
        }
      }

      const hasWhiteboardInCart = this.getSelectedPlans.some(p => p.type === planTypes.ZOOM_WHITEBOARD && p.category === BASE_PLAN_SUB_TYPES.WHITEBOARD_BASIC)
      let isWhiteboardPlus = (this.selectedPlan?.category === BASE_PLAN_SUB_TYPES.WHITEBOARD_PLUS ||
        this.getSelectedPlans.some(p => isPlanIncludeUnlimitedWhiteboard(p))) && !hasWhiteboardInCart
      if (this.pastPlans?.length > 0) {
        isWhiteboardPlus = this.isWhiteboardPlus;
      }

      const infoObj = isWhiteboardPlus ? infoMap[BASE_PLAN_SUB_TYPES.WHITEBOARD_PLUS] : infoMap[BASE_PLAN_SUB_TYPES.WHITEBOARD_BASIC]

      this.category = isWhiteboardPlus ? BASE_PLAN_SUB_TYPES.WHITEBOARD_PLUS : BASE_PLAN_SUB_TYPES.WHITEBOARD_BASIC
      this.configDescription = infoObj.configDescription
      this.description = infoObj.addonDescription || infoObj.configDescription
      this.title = infoObj.title
      this.trackingPlanName = infoObj.trackingPlanName
    },
  },
  created(){
    this.getDefaultTitles()
  }
};
